/** Apenas digitos. */
export function digitsOnly(value: string): string {
  return value.replace(/\D/g, '');
}

/** ISO `yyyy-mm-dd` → exibicao `dd/mm/aaaa`. */
export function isoToDateBr(iso?: string | null): string {
  if (!iso) return '';
  const [y, m, d] = iso.split('-');
  if (!y || !m || !d || y.length !== 4) return '';
  return `${d.padStart(2, '0')}/${m.padStart(2, '0')}/${y}`;
}

/** Exibicao/listagem: ISO → `dd/mm/aaaa` ou travessao. */
export function formatDateBr(iso?: string | null): string {
  const br = isoToDateBr(iso);
  return br || '—';
}

/** Mascara parcial ou completa enquanto digita / no focusout. */
export function formatDateBrInput(value: string): string {
  const d = digitsOnly(value).slice(0, 8);
  if (d.length <= 2) return d;
  if (d.length <= 4) return `${d.slice(0, 2)}/${d.slice(2)}`;
  return `${d.slice(0, 2)}/${d.slice(2, 4)}/${d.slice(4)}`;
}

/** `dd/mm/aaaa` (ou digitos) → ISO `yyyy-mm-dd`; vazio se incompleto ou invalido. */
export function parseDateBrToIso(br: string): string {
  const digits = digitsOnly(br);
  if (digits.length === 0) return '';
  if (digits.length !== 8) return '';

  const dd = Number(digits.slice(0, 2));
  const mm = Number(digits.slice(2, 4));
  const yyyy = Number(digits.slice(4, 8));

  if (mm < 1 || mm > 12 || dd < 1 || dd > 31) return '';

  const date = new Date(yyyy, mm - 1, dd);
  if (
    date.getFullYear() !== yyyy ||
    date.getMonth() !== mm - 1 ||
    date.getDate() !== dd
  ) {
    return '';
  }

  return `${yyyy}-${String(mm).padStart(2, '0')}-${String(dd).padStart(2, '0')}`;
}
